{
  "@context": [
    "https://hubmapconsortium.github.io/ccf-ontology/ccf-context.jsonld",
    {
      "UBERON": {
        "@id": "http://purl.obolibrary.org/obo/UBERON_",
        "@prefix": true
      },
      "illustration_files": {
        "@id": "ccf:image_file",
        "@type": "@id"
      },
      "mapping": {
        "@id": "ccf:illustration_node",
        "@type": "@id"
      },
      "organ_id": {
        "@id": "ccf:organ_id",
        "@type": "@id"
      }
    }
  ],
  "@type": "ccf:FtuIllustration"
}
